<template>
  <edit-order-field :flight-order="flightOrder"
                    :disp-key="dispKey"
                    :disp-value="dispValue"
                    :wrap-form-item="false"
  />
</template>

<script>
import EditOrderField from '@/views/flight-order/components/EditOrderField'

export default {
  name: 'FlightOrderRowCell',
  components: {EditOrderField},
  props: {
    dispKey: {
      type: String,
      default: ''
    },
    dispValue: {
      type: String,
      default: ''
    },
    flightOrder: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/FlightOrderRowCell.vue